/**
 * Defines the authenticated session contract consumed by the backoffice.
 */
import { z } from "zod";
/**
 * Login request for local credentials and an optional active company.
 */
export const BackofficeLoginRequestSchema = z
    .object({
    companySlug: z.string().trim().min(1).max(120).optional(),
    email: z.email().max(254),
    password: z.string().min(8).max(128),
})
    .strict();
const availableCompanySchema = z
    .object({
    name: z.string(),
    slug: z.string(),
})
    .strict();
/**
 * Session response. Refresh credentials remain exclusively in an HttpOnly cookie.
 */
export const BackofficeSessionResponseSchema = z
    .object({
    accessToken: z.string().min(1),
    availableCompanies: z.array(availableCompanySchema),
    expiresInSeconds: z.number().int().positive(),
    tokenType: z.literal("Bearer"),
})
    .strict();
//# sourceMappingURL=IdentityContract.js.map